export default __webpack_public_path__ + "static/media/venta.e2cd8449.jpg";